<template>
    <div :class="'icon-block ' + getExtension(params)">
        <font-awesome-icon
                class="icon"
                size="sm"
                :icon="['fas', 'file-' + getExtension(params)]">
        </font-awesome-icon>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  methods: {
    getExtension(params) {
      const { extension } = params.data;

      const fileTypes = {
        pdf: 'pdf',
        xls: 'excel',
        xlsm: 'excel',
        doc: 'word',
        docx: 'word',
        jpeg: 'image',
        jpg: 'image',
        png: 'image',
      };

      if (fileTypes[extension]) {
        return fileTypes[extension];
      }

      return 'image';
    },
  },
});
</script>

<style lang="scss">
.tooltip-inner {
    padding: 0;
    max-width: 600px;
    text-align: left;
}

.tooltip {
    .arrow:before {
        border-right-color: $primary;
        border-left-color: $primary;
    }
}
</style>
